"use client";

import { useState } from "react";
import { FiMenu, FiSearch } from "react-icons/fi";
import Logo from "../common/Logo";
import SearchBox from "../common/SearchBox";
import NavMenu from "../common/NavMenu";
import HeaderActions from "./HeaderActions";
import LABELS from "@/components/global-constant/src/general";
import SideMenu from "./SideMenu";
import CommonButton from "../common/CommonButton";
import MobileSearchOverlay from "../common/MobileSearchOverlay"; // new component

export default function MainHeader() {
  const [isMenuOpen, setMenuOpen] = useState(false);
  const [showSearch, setShowSearch] = useState(false);

  return (
    <>
      <div className="bg-primary shadow-sm py-4">
        <div className="max-w-7xl mx-auto flex items-center justify-between gap-15 px-4">
          {/* Logo */}
          <div className="w-[25%]  lg:w-[10%]">
            <Logo />
          </div>

          {/* Search box (visible on lg) */}
          <div className="hidden lg:block w-[40%]">
            <SearchBox />
          </div>

          {/* Nav menu (visible on lg) */}
          <div className="hidden lg:block w-[60%]">
            <NavMenu links={LABELS.NAVIGATION} />
          </div>

          {/* Header Actions (cart, login, etc.) on lg */}
          <div className="hidden lg:flex w-[10%] justify-end">
            <HeaderActions />
          </div>

          {/* Mobile Actions */}
          <div className="flex lg:hidden gap-1 ml-auto">
            <CommonButton
              variant="ghost"
              size="icon"
              className="w-10 h-10 p-0"
              onClick={() => setShowSearch(true)}
            >
              <FiSearch className="w-8 h-8 text-primary" />
            </CommonButton>

            <CommonButton
              variant="ghost"
              size="icon"
              className="w-10 h-10 p-0" // match size
              onClick={() => setMenuOpen(true)}
            >
              <FiMenu className="w-9 h-9 text-primary" />
            </CommonButton>
          </div>
        </div>
      </div>

      {/* Side Menu Overlay */}
      {isMenuOpen && <SideMenu onClose={() => setMenuOpen(false)} />}

      {/* Mobile Search Overlay */}
      {showSearch && (
        <MobileSearchOverlay onClose={() => setShowSearch(false)} />
      )}
    </>
  );
}
